import { createSlice } from "@reduxjs/toolkit";

// Slice для управления состоянием загрузки PDF
// нужен чтобы отслеживать состояние загрузки PDF файлов пока текущие файлы не загружены, новые не удастся загрузить
// блокировалась кнопка загрузки PDF
export const UploadExcel = createSlice({
    name: "uploadExcel",
    initialState: {
        upload:false,
    },
    reducers: {
        onChangeUploadExcel: (state, {payload}) => {
            state.upload = payload.upload;
            return state;
        },
    },

});

export const { onChangeUploadExcel } = UploadExcel.actions;
export const UploadExcelSelector = (state) => state.uploadExcel;